<template>
    <div>
        <div class="card" description="Last Campaign Performance">

            <div class="card-header"><h5 class="card-title">
                Remplacement des liens dans les campagnes Mailchimp
            </h5>
                <p class="card-category"></p></div>
            <div class="card-body">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-10 mr-auto ml-auto">
                        <wizard @complete="wizardComplete"
                                nextButtonText="Suivant"
                                prevButtonText="Précédent"
                                finishButtonText="Terminer"
                        >
                            <template slot="header">
                                <h3 class="card-title">Build your profile</h3>
                                <h3 class="description">This information will let us know more about you.</h3>
                            </template>

                            <wizard-tab :before-change="() => validateStep('step1')">
                                <template slot="label">
                                    <!--                                    <i class="nc-icon nc-single-02"></i>-->
                                    <font-awesome-icon style="
                                    display: inline-block;
                                    font-size: 25px;
                                    line-height: initial;
                                    margin-right: 6px;
                                    padding: 0;
                                    vertical-align: bottom;
                                    color: #ffe01b;" icon="fa-brands fa-mailchimp"/>
                                    Campagne mailchimp
                                </template>
                                <first-step ref="step1" :campagne-mailchimp="campagne"
                                            @update-campagne-mailchimp="updateCampagneMailchimp"
                                            @on-validated="onStepValidated"></first-step>
                            </wizard-tab>

                            <wizard-tab :before-change="() => validateStep('step2')">
                                <template slot="label">
                                    <font-awesome-icon style="
                                    display: inline-block;
                                    font-size: 25px;
                                    line-height: initial;
                                    margin-right: 6px;
                                    padding: 0;
                                    vertical-align: bottom;
                                    " icon="fas fa-check-double"/>
                                    Vérification
                                </template>
                                <second-step ref="step2" :campagne-mailchimp="campagne"
                                             @update-campagne-mailchimp="updateCampagneMailchimp"
                                             @on-validated="onStepValidated"></second-step>
                            </wizard-tab>

                            <wizard-tab :before-change="() => validateStep('step3')">
                                <template slot="label">
                                    <font-awesome-icon style="
                                    display: inline-block;
                                    font-size: 25px;
                                    line-height: initial;
                                    margin-right: 6px;
                                    padding: 0;
                                    vertical-align: bottom;
                                    " icon="fas fa-share-square"/>
                                    Enregistrement mailchimp
                                </template>
                                <third-step :campagne-mailchimp="campagne" ref="step3"></third-step>
                            </wizard-tab>
                        </wizard>
                    </div>
                </div>
            </div>
            <div class="card-footer">

                <!--                <div class="stats"><i class="fa fa-check"></i> Campaign sent 2 days ago</div>-->
            </div>
        </div>

    </div>
</template>
<script>
    import FirstStep from './Etapes/Etape1.vue'
    import SecondStep from './Etapes/Etape2.vue'
    import ThirdStep from './Etapes/Etape3.vue'
    import Swal from 'sweetalert2'
    import {Wizard, WizardTab} from 'src/components/UIComponents'
    import router from "../../main";

    export default {
        data() {
            return {
                wizardModel: {},
                campagne: {}
            }
        },
        components: {
            FirstStep,
            SecondStep,
            ThirdStep,
            Wizard,
            WizardTab
        },
        methods: {
            updateCampagneMailchimp(campagne) {
                this.campagne = campagne;
            },
            validateStep(ref) {
                return this.$refs[ref].validate()
            },
            onStepValidated(validated, model) {
                this.wizardModel = {...this.wizardModel, ...model}

            },
            wizardComplete() {
                this.$router.go(this.$router.currentRoute)
            }
        }
    }
</script>
<style>
    /*.moving-tab {*/
        /*font-size: 15px !important;*/
        /*    }*/
</style>
